const TrafficConstants = {
    RAW_TRAFFIC_SUCCESS : 'RAW_TRAFFIC_SUCCESS', 
    RAW_TRAFFIC_FAILURE: 'RAW_TRAFFIC_FAILURE',
    RAW_USAGE_SUCCESS : 'RAW_USAGE_SUCCESS', 
    RAW_USAGE_FAILURE: 'RAW_USAGE_FAILURE',
    RAW_CAPACITY_SUCCESS : 'RAW_CAPACITY_SUCCESS', 
    RAW_CAPACITY_FAILURE: 'RAW_CAPACITY_FAILURE',

};

export default TrafficConstants;